import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'RankGold',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { width: "25", height: "30", viewBox: "0 0 25 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M3.16699 27.6552V18.2612H21.8337V27.6552C21.8337 28.6435 20.7215 29.2232 19.9114 28.6571L13.2004 23.9677C12.7799 23.6739 12.2207 23.6739 11.8003 23.9677L5.08927 28.6571C4.27912 29.2232 3.16699 28.6435 3.16699 27.6552Z", fill: "#E5A900" }
      }), h("path", {
        attrs: { d: "M24.5 11.739C24.5 18.2215 19.1266 23.478 12.5 23.478C5.87344 23.478 0.5 18.2215 0.5 11.739C0.5 5.25658 5.87344 0 12.5 0C19.1266 0 24.5 5.25658 24.5 11.739Z", fill: "#FFDC48" }
      }), h("path", {
        attrs: { d: "M21.8337 11.7392C21.8337 16.7858 17.6525 20.8696 12.5003 20.8696C7.34817 20.8696 3.16699 16.7793 3.16699 11.7392C3.16699 6.69913 7.34817 2.60889 12.5003 2.60889C17.6525 2.60889 21.8337 6.69913 21.8337 11.7392Z", fill: "#E5A900" }
      }), h("path", {
        attrs: { d: "M11.7823 8.41156H10.2252V7.347C10.6701 7.12456 11.0885 6.89152 11.4804 6.64789C11.8724 6.40426 12.2325 6.14474 12.5609 5.86933H13.5619V17.5H11.7823V8.41156Z", fill: "#FFDC48" }
      })]
    );
  }
};